import Hotjar from "@hotjar/browser";
import { APP_ENV, HOTJAR_SITE_ID } from "../config";

const HOTJAR_VERSION = 6;

// appends a property value to the name, since Hotjar drops properties
// (modal_dismissed → modal_dismissed-signup_promo)
const withModal = (name, { modal }) => (modal ? [`${name}-${modal}`] : []);

// extra Hotjar event names sent alongside the catalogue name
const ALIASES = {
  // pre-catalogue names, still sent so existing recording filters keep matching
  editor_opened: ({ source }) => [
    "editorOpen",
    source === "custom_mix" ? "editorOpen-customMix" : "editorOpen-initialTrack"
  ],
  // per-modal names so recordings can be filtered by which modal
  modal_shown: props => withModal("modal_shown", props),
  modal_dismissed: props => withModal("modal_dismissed", props),
  modal_converted: props => withModal("modal_converted", props)
};

/**
 * heatmaps and recordings, production only
 * - events become Hotjar recording filters (names only, no properties)
 */
const hotjarDestination = {
  name: "hotjar",
  preference: "replay",
  enabled: () => APP_ENV === "production" && Boolean(HOTJAR_SITE_ID),
  init: () => Hotjar.init(HOTJAR_SITE_ID, HOTJAR_VERSION),
  track: (name, props) =>
    [name, ...(ALIASES[name]?.(props) ?? [])].forEach(event =>
      Hotjar.event(event)
    ),
  identify: (userId, traits) => Hotjar.identify(userId, traits),
  reset: () => {},
  page: () => {}
};

export default hotjarDestination;
